import axios, { AxiosRequestConfig } from 'axios';
import { getTokenString } from './auth';

export const submitEntry = async (
  challengeId: string,
  name: string,
  entry: { docker: string; tasks: string[] }, // specific to maniskill 2022
  description: string = '',
  tags: string[]
) => {
  let tokenStr = getTokenString();
  return axios
    .post(
      `${process.env.REACT_APP_API}/v1/challenges/${challengeId}/submission`,
      {
        name: name,
        tags: JSON.stringify(tags),
        description,
        entry,
      },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Token: ${tokenStr}`,
        },
      }
    )
    .then((res) => res.data);
};

export interface SubmissionEntry {
  description: string;
  error: string[];
  status: string; // TODO: change to enum
  name: string;
  results: number[];
  userId: string;
  challengeId: string;
  submissionDate: number;
  id: string;
  tags?: string[];
  teamId: string;
  teamName: string;
  progress: progress;
  entry: any;
}
export type progress = {
  [key: string]: progress | number | undefined;
};

export const getSubmissionEntries = async (
  challengeId: string
): Promise<SubmissionEntry[]> => {
  let tokenStr = getTokenString();
  return axios
    .get(
      `${process.env.REACT_APP_API}/v1/challenges/${challengeId}/submission`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Token: ${tokenStr}`,
        },
      }
    )
    .then((res) => {
      return res.data.submissions;
    });
};

export const getTeamSubmissionEntries = async (
  challengeId: string,
  teamId: string,
  limit: number = 100,
  page: number = 0,
  sortKey: string = "submissionDate",
  sortOrder: string = "desc",
): Promise<{submissions: SubmissionEntry[], total: number}> => {
  let tokenStr = getTokenString();
  const offset = page * limit;
  let sortOrderNum = -1;
  if (sortOrder === "desc") {
    sortOrderNum = -1;
  } else {
    sortOrderNum = 1;
  }
  console.log({sortOrder, sortOrderNum})
  return axios
    .get(
      `${process.env.REACT_APP_API}/v1/challenges/${challengeId}/team/${teamId}/submission?limit=${limit}&offset=${offset}&sortBy=${sortKey}&sortOrder=${sortOrderNum}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Token: ${tokenStr}`,
        },
      }
    )
    .then((res) => {
      return res.data;
    });
};

export const getAllSubmissionEntries = async (
  challengeId: string,
  limit: number = 100,
  page: number = 0,
  sortKey: string = "submissionDate",
  sortOrder: string = "desc",
): Promise<{submissions: SubmissionEntry[], total: number}> => {
  let tokenStr = getTokenString();
  const offset = page * limit;
  let sortOrderNum = -1;
  if (sortOrder === "desc") {
    sortOrderNum = -1;
  } else {
    sortOrderNum = 1;
  }
  return axios
    .get(
      `${process.env.REACT_APP_API}/v1/challenges/${challengeId}/allsubmissions?limit=${limit}&offset=${offset}&sortBy=${sortKey}&sortOrder=${sortOrderNum}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Token: ${tokenStr}`,
        },
      }
    )
    .then((res) => {
      return res.data;
    });
};

export const createChallenge = async (data: {
  name: string;
  description: string;
  metrics: string[];
  levels: [number, number];
  env: string;
}) => {
  let tokenStr = getTokenString();
  let res = await axios.post(
    `${process.env.REACT_APP_API}/v1/challenges/`,
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Token: ${tokenStr}`,
      },
    }
  );
  return res;
};

export const getChallenge = async (challengeId: string) => {
  return axios
    .get(`${process.env.REACT_APP_API}/v1/challenges/${challengeId}`, {
      headers: {
        Accept: 'application/json',
      },
    })
    .then((res) => {
      return res.data;
    });
};

export const hideChallenge = async (challengeId: string, hidden: boolean) => {
  let tokenStr = getTokenString();
  return axios
    .patch(
      `${process.env.REACT_APP_API}/v1/challenges/${challengeId}/`,
      {
        hidden,
      },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Token: ${tokenStr}`,
        },
      }
    )
    .then((res) => {
      return res.data;
    });
};

export const fetchRegistration = async (challengeId: string) => {
  let tokenStr = getTokenString();
  return axios
    .get(
      `${process.env.REACT_APP_API}/v1/challenges/${challengeId}/registration`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Token: ${tokenStr}`,
        },
      }
    )
    .then((res) => {
      return res.data;
    });
};
